import React, { useEffect, useState } from "react";
import { db } from "./firebase";
import { collection, getDocs, updateDoc, doc } from "firebase/firestore";
import "./UserList.css";

export default function UserList() {
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState("");

  useEffect(() => {
    async function fetchUsers() {
      const snapshot = await getDocs(collection(db, "users"));
      const data = snapshot.docs.map(doc => ({
        uid: doc.id,
        ...doc.data(),
        walletInput: doc.data().wallet || 0
      }));
      setUsers(data);
    }
    fetchUsers();
  }, []);

  const handleInputChange = (uid, value) => {
    setUsers(prev =>
      prev.map(user =>
        user.uid === uid ? { ...user, walletInput: value } : user
      )
    );
  };

  const updateWallet = async (uid, newAmount) => {
    const userRef = doc(db, "users", uid);
    await updateDoc(userRef, {
      wallet: Number(newAmount)
    });

    setUsers(prev =>
      prev.map(user =>
        user.uid === uid
          ? { ...user, wallet: Number(newAmount), walletInput: Number(newAmount) }
          : user
      )
    );
  };

  const filteredUsers = users.filter(
    u =>
      u.name?.toLowerCase().includes(search.toLowerCase()) ||
      u.email?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="userlist-container">
      <h2>Registered Users</h2>

      <input
        type="text"
        placeholder="Search by name or email"
        value={search}
        onChange={e => setSearch(e.target.value)}
        style={{
          marginBottom: "15px",
          padding: "8px",
          width: "100%",
          maxWidth: "400px",
          borderRadius: "5px",
          border: "1px solid #ccc"
        }}
      />

      {filteredUsers.length === 0 ? (
        <p>No users found.</p>
      ) : (
        <table className="userlist-table">
          <thead>
            <tr>
              <th>#</th>
              <th>UID</th>
              <th>Name</th>
              <th>Email</th>
              <th>Wallet</th>
              <th>Update</th>
            </tr>
          </thead>
          <tbody>
            {filteredUsers.map((u, i) => (
              <tr key={u.uid}>
                <td>{i + 1}</td>
                <td>{u.uid}</td>
                <td>{u.name || "-"}</td>
                <td>{u.email || "-"}</td>
                <td>
                  <input
                    type="number"
                    value={u.walletInput}
                    onChange={e => handleInputChange(u.uid, e.target.value)}
                    style={{ width: "80px" }}
                  />
                </td>
                <td>
                  <button onClick={() => updateWallet(u.uid, u.walletInput)}>
                    Save
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
